/* eslint-disable import/no-require */
import React from 'react';
import { Redirect, Route, IndexRoute } from 'react-router';
import offlineIntercept from '../components/onffline_intercept.jsx';
import contentIntercept from '../components/content_intercept.jsx';
import TermView from '../components/term_view.jsx';
import AllNotes from '../components/all_notes.jsx';
import EngageReader from 'components/engage_reader';

export default (
    <Route component={require('../controllerviews/login.jsx').default}>
        <Route
            path="/"
            component={require('../controllerviews/app.jsx').default}
        >
            <IndexRoute component={require('../components/root.jsx').default} />

            <Route
                path="content-:contentId"
                component={contentIntercept(
                    require('../controllerviews/content.jsx').default
                )}
            >
                <Route path="address/:pagenum" component={EngageReader}>
                    <Route
                        path="print"
                        component={
                            require('../components/engage_reader/print_dialog.jsx')
                                .default
                        }
                    />
                    <Route
                        path="sharing"
                        component={
                            require('../components/engage_reader/sharing.jsx')
                                .default
                        }
                    />
                </Route>
            </Route>

            <Route
                path="notes/content-:contentId"
                component={contentIntercept(AllNotes)}
            >
                <Route
                    path="new"
                    component={
                        require('../controllerviews/note_dialog.jsx').default
                    }
                />

                <Route
                    path="edit/:noteId"
                    component={
                        require('../controllerviews/note_dialog.jsx').default
                    }
                />

                <Route
                    path="sharing"
                    component={
                        require('../components/engage_reader/sharing.jsx')
                            .default
                    }
                />
            </Route>

            <Route
                path="search/:queryText"
                component={offlineIntercept(
                    require('../components/search.jsx').default
                )}
            />

            <Route
                path="search/:queryText/:context"
                component={offlineIntercept(
                    require('../components/search.jsx').default
                )}
            />

            <Route
                path="section/:sectionId"
                component={require('../components/section_view.jsx').default}
            >
                <Route
                    path="analytics/:contentId"
                    component={
                        require('../components/analytics_dialog.jsx').default
                    }
                />

                <Route
                    path="manage/:manage"
                    component={
                        require('../components/manage_content.jsx').default
                    }
                />
            </Route>

            <Route path="term/:termId" component={TermView}>
                <Route
                    path="logout"
                    component={require('../components/logout.jsx').default}
                />

                <Route
                    path="analytics/:contentId"
                    component={
                        require('../components/analytics_dialog.jsx').default
                    }
                />

                <Route
                    path="manage/:manage"
                    component={
                        require('../components/manage_content.jsx').default
                    }
                />
            </Route>
        </Route>
        <Redirect from="*" to="/" />
    </Route>
);



// WEBPACK FOOTER //
// ./src/router/routes.jsx